import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';

const formatDate = (date) => {
  if (!date) return null;
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return date;
  return parsed.toLocaleDateString('pt-BR');
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  card: {
    border: '1px solid #E6E7EB',
    borderRadius: 12,
    background: '#FFFFFF',
    boxShadow: '0 1px 2px rgba(16,24,40,.04), 0 4px 12px rgba(16,24,40,.06)',
  },
  cardBody: {
    padding: '18px 20px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: 8,
  },
  titleWrap: {},
  title: {
    margin: 0,
    marginBottom: 4,
    color: '#0F172A',
    fontWeight: 600,
    letterSpacing: '0.2px',
    fontSize: '1rem',
    lineHeight: 1.3,
  },
  subtitle: {
    color: '#475569',
    fontSize: '.95rem',
  },
  badgeCurrent: {
    alignSelf: 'flex-start',
    background: '#EEF2F6',
    color: '#334155',
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 600,
    padding: '6px 10px',
    borderRadius: 999,
    letterSpacing: '.4px',
    border: '1px solid #E6E7EB',
  },
  metaRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 12,
  },
  metaLabel: {
    color: '#475569',
    fontWeight: 600,
    fontSize: '.9rem',
  },
  metaValue: {
    color: '#334155',
    fontSize: '.95rem',
  },
  detalhes: {
    marginTop: 12,
  },
  detalhesLabel: {
    color: '#475569',
    fontWeight: 600,
    fontSize: '.9rem',
    marginBottom: 4,
  },
  detalhesText: {
    color: '#334155',
    margin: 0,
    lineHeight: 1.5,
  },
  muted: {
    color: '#64748B',
    fontSize: '.95rem',
  },
};

const ExperienciasProfissionais = ({ experiencias = [] }) => {
  if (!experiencias || experiencias.length === 0) {
    return (
      <div style={styles.muted}>
        Nenhuma experiencia profissional informada.
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {experiencias.map((exp) => {
        const inicio = formatDate(exp?.DataInicio);
        const fim = exp?.EmpregoAtual ? 'Atual' : formatDate(exp?.DataFinal);
        const exibePeriodo = inicio || fim;

        return (
          <Card
            key={exp?.id || `${exp?.NomeEmpresa}-${exp?.Cargo}-${inicio || ''}`}
            style={styles.card}
          >
            <CardBody style={styles.cardBody}>
              <div style={styles.headerRow}>
                <div style={styles.titleWrap}>
                  <h6 style={styles.title}>
                    {exp?.Cargo || 'Cargo nao informado'}
                  </h6>
                  <div style={styles.subtitle}>
                    {exp?.NomeEmpresa || 'Empresa nao informada'}
                  </div>
                </div>

                {exp?.EmpregoAtual ? (
                  <span style={styles.badgeCurrent}>Emprego atual</span>
                ) : null}
              </div>

              {exibePeriodo ? (
                <div style={styles.metaRow}>
                  <span style={styles.metaLabel}>Período</span>
                  <span style={styles.metaValue}>
                    {inicio || 'Data inicial nao informada'} — {fim || 'Data final nao informada'}
                  </span>
                </div>
              ) : null}

              {exp?.Detalhes ? (
                <div style={styles.detalhes}>
                  <div style={styles.detalhesLabel}>Detalhes</div>
                  <p style={styles.detalhesText}>{exp.Detalhes}</p>
                </div>
              ) : null}

              {exp?.SemExperiencia ? (
                <div style={{ ...styles.muted, marginTop: 8 }}>
                  Marcado como sem experiencia anterior.
                </div>
              ) : null}
            </CardBody>
          </Card>
        );
      })}
    </div>
  );
};

export default ExperienciasProfissionais;
